import { MiddlewareAPI, Dispatch, Action } from 'redux';
import { ThunkDispatch } from 'redux-thunk';
import moment from 'moment';

import { pushGenie } from '../api';
import {
    CALC_NAME_TO_ID,
    DEFAULT_PAD_CONFIG_KEY_SET,
    DENTAL_CHART,
    GROWTH_CHART_RESULTS,
    GROWTH_CHART_VITALS,
    GenieVersion,
    LOCAL_ID_PREFIX,
    PAD_CONFIG_FOLLOW_UP_ADVICES_ID,
    PRINT_CONFIGS_KEYS_TO_LABEL,
} from '../constants';
import { Actions } from './actions';
import {
    DELETE_DIAGNOSE,
    DELETE_SYMPTOM,
    UPSERT_DIAGNOSE,
    UPSERT_SYMPTOM,
    cacheDrugsLabTestsFromSymDia,
    cacheRelatedSymDiaFromSymDia,
    LOAD_PRESCRIPTION,
    LOAD_PRESCRIPTION_TEMPLATE,
    UPSERT_MEDICATION,
    DELETE_MEDICATION,
    cacheDrugInteractions,
    UNDO_ACTION,
    cacheSymDiaProperties,
    cacheComplimentaryDrugs,
    APPLY_DRAFT,
    setFollowup,
    UPSERT_DYFORM,
    UPSERT_LAB_TEST,
    SHOW_DIALOG,
    HIDE_DIALOG,
    UPDATE_FOLLOWUP,
    COPY_DURATION_IN_MED,
    SWAP_PX_ELEMENTS,
    fetchAndCacheLabsForReferal,
    DELETE_LAB_TEST,
    UPDATE_LAB_TO_REFER_ID,
    updateLabReferal,
    CLEAR_PRESCRIPTION,
    fetchAndCachePtVitals,
    SET_TOAST_TYPE,
    CREATE_PRESCRIPTION_TEMPLATE,
    updateInventory,
    cachePatientDetails,
    loadPrintConfig,
    upsertMedicalHistory,
    UPDATE_VITALS,
    setVitals,
    upsertPrescription,
    sanitizePrescription,
    applyDraft,
    setToastType,
    UPSERT_PRESCRIPTION,
    loadTranslate,
    UpsertMedicationAction,
    UpsertLabTestAction,
    updateMedications,
    updateLabTests,
    setDrugsSubstitute,
    REPLACE_HE_MEDICATION,
    FINISH_PRESCRIPTION,
    setDoctorPackages,
    FETCH_DRUGS_SUBSTITUTE,
    DELETE_VITALS,
    UPDATE_PATIENT,
    setOngoingTreatmentPlans,
    setupPadGenieAutoSuggest,
    SETUP_PAD_GENIE_AUTO_SUGGEST,
    COPY_CARE_CANVAS,
    upsertCareCanvas,
    copyCareCanvas,
    UPSERT_PRESCRIPTION_V2,
    fetchAndUpdateLatestDrugInfo,
} from './actions/prescriptionPad';
import { CREATE_VISIT } from './actions/visit';

import {
    GAdvice,
    GDyForm,
    GFollowUp,
    GLabTest,
    GLabVitalEntity,
    GLTTemplate,
    GMedTemplate,
    GSymTemplate,
    GDiaTemplate,
    GMedFrequency,
    GMedication,
    GMedSOA,
    GMedTiming,
    GRefer,
    GService,
    GSymptomsDiagnosis,
    GVitals,
    GLabVitalTemplate,
    GExaminationsTemplate,
    GenieItem,
    SectionNameConfig,
    GInjectionTemplate,
    GInjection,
    GProceduresTemplate,
} from './db';
import { DB_TABLES } from './dbTables';
import {
    clearTable,
    getDoc,
    getGArray,
    getInventory,
    getInventoryV2,
    getItemFromMisc,
    getMySingleDoctorId,
    getPrintConfig,
    getPtColumns,
    getSelectedClinicId,
    MISC_KEYS,
    updateG,
    updateMhErrorInPx,
    updateMhInPx,
} from './idbHandler';
import { GlobalState, GlobalStateV1 } from './reducers';
import fetchPtMedHistory from '../api/fetchPtMedHistory';
import openVC from '../pages/videoRef';
import {
    Age,
    DentalProcedure,
    DiagnosisEntityOrSymptomsEntity,
    GMedicalRecordsTags,
    LabVitalEntity,
    MedicationsEntity,
    Prescription,
    PX_OP_KEYS,
    Tool,
    VitalsEntity,
} from './types/prescription';
import { fetchAndCacheAssessmentSummary, triggerStartVisitOnBE } from './actions/app';
import {
    ExtraFlags,
    GCalculatorsConfig,
    GenieKeys,
    GeniePadElementsSettingItem,
    GenieSettings,
    GMedicalHistoryConfig,
    GVitalConfig,
    SR,
    VitalsSelectedItemsType,
} from '../api/pushGenie';
import { track } from '../tracking';
import { Translate } from '../api/pushVisit';
import {
    ANSWER_SNACKING_QUESTION,
    fetchSnackingQuestions,
    FETCH_SNACKING_QUESTIONS,
    TOGGLE_GOOGLE_REVIEW_DIALOG,
    UPDATE_GENIE_SETTINGS,
    UPSERT_GENIE_SETTINGS,
} from './actions/session';
import {
    getAvailableToReferData,
    getLabsAvailableToRefer,
    getLabTests,
    getPrescription,
    getSelectedLabToReferId,
} from './selectors/prescriptionPad';
import { DocNetworkEntity } from '../api/fetchSpecialityForDoctor';
import { createDBTool, filterIdUsingStartsWithAndJoin, mergeVitals } from './utils';
import { batch } from 'react-redux';
import { MEDICAL_HISTORY_CATEGORY, MHC } from './types/medicalHistory';
import { getPxElementConfig } from './selectors/session';
import { captureError, captureErrorString } from '../pages/captureError';
import fetchPxDraft from '../api/fetchPxDraft';
import { PatientDetailsVisits } from './reducers/prescriptionPad';
import getSnackingQuestions from '../api/getSnackingQuestions';
import answerSnackingQuestions from '../api/answerSnackingQuestions';
import { fetchMyGenie } from './actions/login';
import omit from 'lodash/omit';
import {
    fetchAndStoreGrowthChartData,
    fetchDrugsLabTestsStatus,
    isOnboardedForLab,
    isOnboardedForPharma,
} from '../pages/utils';
import { ItemType } from '../components/prescriptionPad/rightPanel/workspace/PrescribeAutoSuggestV2';
import {
    PARCHI_SNACKING_QUESTIONS_VERSION,
    SNACKING_DOCTOR_PROFILE,
    SNACKING_QUESTIONS_FETCH_DATE,
    SNACKING_QUESTIONS_VERSION,
} from '../pages/SnackingQuestionsComponent';
import fetchDrugsSubstitute from '../api/fetchDrugsSubstitute';
import fetchDoctorPackages from '../api/fetchDoctorPackages';
import { getGrowthChartZindexAndPercentileVitals } from '../components/prescriptionPad/rightPanel/workspace/padV2/growthChart/constants/utils';
import { removeUnwatedKeys } from '../components/prescriptionPad/rightPanel/workspace/padV2/VitalAutoSuggest';
import { notification } from 'antd';
import { getMyDbId } from '../api/mactiveid';
import setupRedux from './setupAppRedux';
import PadGenieAutoSuggestFuseManager from '../components/prescriptionPad/PadGenieAutoSuggestFuseManager';
import { changeVitalIdFromVToLBInVitalsConfig } from '../components/prescriptionPad/leftPanel/vitals';
import {
    BMI_ID,
    HEIGHT_ID,
    WEIGHT_ID,
} from '../components/prescriptionPad/rightPanel/workspace/padV2/VitalTable';
import { fillBMI } from '../utils/bmi';
import getCareCanvasTemplate from '../api/getCareCanvasTemplate';
import uploadCareCanvasTemplate from '../api/uploadCareCanvasTemplate';
import { CareCanvas } from './types/CareCanvas';
import {
    imageToBase64,
    uploadImage,
} from '../components/prescriptionPad/rightPanel/workspace/CareCanvas/utils';
import { getDefiniteMActiveId } from './localstorage';
import { getColumns, getUITable, OptionTypeBase } from '../pages/opUtils';

const getTrackingRelevantDataFromAction = (
    action: Actions,
): { [k: string]: string } | undefined => {
    switch (action.type) {
        case UPSERT_SYMPTOM:
        case UPSERT_DIAGNOSE:
        case UPSERT_MEDICATION:
        case UPSERT_LAB_TEST:
            return action.index !== undefined ? { index: action.index.toString() } : undefined;
        case SHOW_DIALOG:
        case HIDE_DIALOG:
            return { which: action.which };
        case UPDATE_FOLLOWUP:
            return { date: action.date ? 'SET/UPDATE' : 'UNSET' };
        case UPDATE_GENIE_SETTINGS:
            return { which: action.key, to: `${action.value}` };
        case UPSERT_GENIE_SETTINGS:
            return { which: Object.keys(action.setting).join(',') + action.oid };
        case SWAP_PX_ELEMENTS:
            return { what: action.what };
        case TOGGLE_GOOGLE_REVIEW_DIALOG:
            return { visibile: `${action.isGoogleReviewDialogVisible}` };
        case SET_TOAST_TYPE:
            return { type: action.type };
        case LOAD_PRESCRIPTION_TEMPLATE:
            return { entity: action.entity };
        case FINISH_PRESCRIPTION:
            return {
                visitId: action.px?.visitId ?? '',
                patient_id: action.px?.patient.localId ?? '',
            };
        case CREATE_PRESCRIPTION_TEMPLATE:
            if (action.entity === 'labTests' && action.isPackage) {
                return {
                    entity: action.entity,
                    isNew: (action.id === undefined).toString(),
                    packageInfo: action.id ? 'LABS_PACKAGE_UPDATED' : 'LABS_PACKAGE_CREATED',
                };
            }
            return { entity: action.entity, isNew: (action.id === undefined).toString() };
        case ANSWER_SNACKING_QUESTION:
            const { newMed, skipPushToBE } = action;
            if (Array.isArray(newMed)) {
                const unCodedMedicines = newMed.filter((i) => i.id.startsWith(LOCAL_ID_PREFIX));
                return {
                    codedMeds: String(newMed.length - unCodedMedicines.length),
                    uncodedMeds: String(unCodedMedicines.length),
                };
            }
            const { replaced_from, suggestions, is_otc, med_cat } = newMed;
            const selectedSuggestionId = is_otc ? 'otc' : med_cat || 'nota';
            if (replaced_from) {
                return { currentMedId: replaced_from.id, selectedSuggestionId: newMed.id };
            }
            return {
                currentMedId: newMed.id,
                selectedSuggestionId: skipPushToBE ? 'skip' : selectedSuggestionId,
                skippedSuggestionId: suggestions?.map((i) => i.id).join(', ') || 'skip',
            };
        default:
            return undefined;
    }
};

const handleAction = async (
    action: Actions,
    state: GlobalState,
    dispatch: ThunkDispatch<GlobalState, null, Actions>,
): Promise<void> => {
    track(action.type, getTrackingRelevantDataFromAction(action));

    switch (action.type) {
        case UPDATE_VITALS:
            if (!state.prescriptionPad.prescription?.vitals?.length) {
                break;
            }
            const isGrowthChartEnabled = state?.session?.growthChart;
            let rxVitals = state.prescriptionPad.prescription?.vitals;
            const selectedItems = state.session.padConfig?.vitalsPadConfig?.selectedItems || [];
            const selectedCalculators = state.session.padConfig?.calculatorPadConfig?.selectedItems?.map(
                (i) => CALC_NAME_TO_ID[i.key],
            );
            const growthChartVitals: VitalsSelectedItemsType[] = [];
            if (isGrowthChartEnabled) {
                const selectedIds = new Set(selectedItems?.map((item) => item.id));
                GROWTH_CHART_VITALS.forEach((i) => {
                    if (!selectedIds.has(i.id)) {
                        growthChartVitals?.push({ id: i.id, name: i.name });
                    }
                });
            }

            if (
                selectedItems?.find((t) => t.id === BMI_ID) &&
                (action.vitals.id === HEIGHT_ID || action.vitals.id === WEIGHT_ID)
            ) {
                const height =
                    action.vitals.id === HEIGHT_ID
                        ? action.vitals
                        : rxVitals.find((v) => v.id === HEIGHT_ID);
                const weight =
                    action.vitals.id === WEIGHT_ID
                        ? action.vitals
                        : rxVitals.find((v) => v.id === WEIGHT_ID);
                if (height?.value.qt && weight?.value.qt) {
                    const bmi = fillBMI({
                        height: height.value.qt,
                        weight: weight.value.qt,
                        weightUnit: weight.value.code_id || '',
                        heightUnit: height.value.code_id || '',
                    });

                    if (bmi) {
                        rxVitals = [...rxVitals.filter((v) => v.id !== BMI_ID), bmi];
                    }
                }
            }

            const map = rxVitals?.reduce((t, v) => {
                t[v.id] = v;
                return t;
            }, {} as { [k: string]: VitalsEntity });
            if (!map) {
                break;
            }
            const orderedList: VitalsEntity[] =
                selectedItems?.map((t) => map[t.id]).filter(Boolean) || [];

            const calculatorVitalList: VitalsEntity[] =
                selectedCalculators?.map((id) => map[id]).filter(Boolean) || [];

            const growthChartVitalList: VitalsEntity[] =
                growthChartVitals?.map((t) => map[t.id]).filter(Boolean) || [];

            const gender = state.prescriptionPad.prescription?.patient?.profile?.personal?.gender;
            const age = state.prescriptionPad.prescription?.patient?.profile?.personal?.age;

            dispatch(setVitals([...orderedList, ...calculatorVitalList, ...growthChartVitalList]));

            if (isGrowthChartEnabled) {
                onGrowthChartChange(
                    dispatch,
                    [...orderedList, ...calculatorVitalList, ...growthChartVitalList],
                    gender as 'male' | 'female',
                    age,
                );
            }
            break;

        case UPDATE_PATIENT:
        case DELETE_VITALS:
            if (!state.prescriptionPad.prescription?.vitals?.length) {
                break;
            }
            const excludedGrowthVitals: VitalsEntity[] = state.prescriptionPad.prescription?.vitals.filter(
                (v) => !GROWTH_CHART_RESULTS?.[v.id],
            );

            const pGender = state.prescriptionPad.prescription?.patient?.profile?.personal?.gender;
            const pAge = state.prescriptionPad.prescription?.patient?.profile?.personal?.age;
            const isGrowthChartEnable = state?.session?.growthChart;

            if (isGrowthChartEnable) {
                onGrowthChartChange(
                    dispatch,
                    excludedGrowthVitals,
                    pGender as 'male' | 'female',
                    pAge,
                );
            }

            break;
        case UPSERT_LAB_TEST:
        case DELETE_LAB_TEST:
        case UPDATE_LAB_TO_REFER_ID:
        case CLEAR_PRESCRIPTION:
            setLabRefer(state, dispatch);
            addLabTestsStatus(dispatch, state, action);
            break;

        case UPSERT_GENIE_SETTINGS: {
            if (!state.prescriptionPad.prescription) break;

            const pres = state.prescriptionPad.prescription;

            onSymDiaChange(dispatch, action, pres?.symptoms, pres?.diagnosis, false);
            onMedicationChange(pres?.medications || [], dispatch, action);

            if (action.setting.autoFillFollowUp) {
                const meds = state.prescriptionPad.prescription?.medications;
                if (meds) {
                    computeFollowUpfromMedDuration(meds, dispatch, state);
                }
            }
            break;
        }

        case CREATE_VISIT: {
            const docId = action.visit.docid || getDoc()?._id;

            if (!docId) {
                console.error('Doc not found');
                break;
            }

            if (action.visit.visitType === 'TELE' && !action.visit.saId) {
                // openVC(action.meta.patient.name, action.visit.id);
            }

            // this aren't that important, should not block render thread
            // thus make them least priority
            // checkout https://javascript.info/event-loop#summary
            Promise.resolve().then(() =>
                setTimeout(async () => {
                    if (!action.meta.avoidTriggerBEStartVisit) {
                        dispatch(
                            triggerStartVisitOnBE({
                                visitId: action.visit.id,
                                startedAt: new Date().toISOString(),
                                clinicId: action.visit.clinicId || getSelectedClinicId() || '',
                                docId,
                                patient: action.meta.patient,
                                pid: action.visit.patient.id,
                                abortVisitId: action.meta.abortVisitId,
                            }),
                        );
                    }

                    if (action.meta.patient.id) {
                        try {
                            const response = await fetchPtMedHistory(docId, action.meta.patient.id);
                            if (response.data) {
                                await updateMhInPx(action.visit.prescriptionId, response.data);

                                batch(() => {
                                    Object.keys(response.data || {})?.forEach((catId) => {
                                        response.data &&
                                            response.data[catId as keyof MHC]?.forEach((item) => {
                                                dispatch(
                                                    upsertMedicalHistory(
                                                        catId as MEDICAL_HISTORY_CATEGORY,
                                                        item,
                                                    ),
                                                );
                                            });
                                    });
                                });
                            } else {
                                await updateMhErrorInPx(action.visit.prescriptionId);
                                console.error('fetch mh failed', response);
                            }
                        } catch (e) {
                            await updateMhErrorInPx(action.visit.prescriptionId);
                        }
                    } else {
                        console.error("Can't fetch pt MH, pt id not found");
                    }
                }),
            );

            break;
        }

        case APPLY_DRAFT: {
            if (!state.prescriptionPad.prescription) break;
            const vitals = state.prescriptionPad.prescription.labVitals;

            const { padVisits, treatmentProcedures } = action;
            autoCopy(
                state,
                dispatch,
                padVisits?.data?.map((t) => ({
                    ...createDBTool(t),
                    date: t.date,
                    visitId: t.visitId,
                    precriptionId: t.id,
                    flavour: t.flavour,
                    translateLang: t.translateLang,
                })),
                vitals,
                treatmentProcedures,
            );

            onSymDiaChange(
                dispatch,
                action,
                state.prescriptionPad.prescription.symptoms,
                state.prescriptionPad.prescription.diagnosis,
                true,
            );
            state.prescriptionPad.prescription.medications &&
                onMedicationChange(
                    state.prescriptionPad.prescription.medications,
                    dispatch,
                    action,
                );

            updatePrintConfigWithDForm(state, dispatch);
            break;
        }

        case UPSERT_SYMPTOM:
        case DELETE_SYMPTOM:
        case UPSERT_DIAGNOSE:
        case DELETE_DIAGNOSE: {
            if (!state.prescriptionPad.prescription) break;

            onSymDiaChange(
                dispatch,
                action,
                state.prescriptionPad.prescription.symptoms,
                state.prescriptionPad.prescription.diagnosis,
                true,
            );
            break;
        }

        case UPSERT_DYFORM:
            PRINT_CONFIGS_KEYS_TO_LABEL[action.dyform.id] = action.dyform.name;
            break;

        case LOAD_PRESCRIPTION:
            if (!state.prescriptionPad.prescription) break;

            const px = state.prescriptionPad.prescription;
            const filters = action.filters;

            // TODO: optimise it, check if current setup is of the same doctor, avoid it
            setupRedux(
                dispatch,
                px.doctor._id,
                () => {
                    console.log('Setup redux success');
                    return;
                },
                () => {
                    console.log('Access control success');
                    return;
                },
                false,
                getDefiniteMActiveId(),
                filters,
                true
            );

            dispatch(
                cachePatientDetails(px.patient.id || px.patient.localId, false, undefined, px.id),
            );
            const { isTreatmentPlanEnabled } = state.session;
            fetchPxDraft(px.visitId, px.patient.id || px.patient.localId, isTreatmentPlanEnabled)
                .then((res) => {
                    batch(() => {
                        dispatch(
                            applyDraft(
                                res.response,
                                px.meta?.autoCopyStatus === 'REQUIRED'
                                    ? res.padVisits
                                    : {
                                          success: res.padVisits?.success ?? true,
                                          data: [],
                                      },
                                res.treatmentProcedures,
                            ),
                        );

                        if (!res.response.self) {
                            dispatch(setToastType('summary'));
                        }

                        if (Array.isArray(res.ongoingTreatmentPlans)) {
                            dispatch(setOngoingTreatmentPlans(res.ongoingTreatmentPlans));
                        }
                    });
                })
                .catch(console.error);

            setTimeout(async () => {
                updatePrintConfigWithDForm(state, dispatch);

                onSymDiaChange(dispatch, action, px.symptoms, px.diagnosis, true);

                dispatch(
                    fetchAndCacheAssessmentSummary({
                        visitId: px.visitId,
                    }),
                );

                px.medications && onMedicationChange(px.medications, dispatch, action);

                const translate = await getItemFromMisc<Translate>(
                    getMyDbId() || '',
                    MISC_KEYS.translate,
                );

                const ptLang = state.prescriptionPad.prescription?.patient.formData?.find(
                    (t) => t.key === 'lang',
                )?.value;

                if (ptLang) {
                    dispatch(
                        loadTranslate({
                            ...translate,
                            lang: ptLang.toString(),
                        }),
                    );
                } else {
                    !state.prescriptionPad.translate && dispatch(loadTranslate(translate));
                }

                // const inventoryV2 = await getInventoryV2(px.clinic._id);

                // if (inventoryV2) {
                //     dispatch(updateInventory(inventoryV2));
                // } else {
                //     const inventory = (await getInventory()) || {};
                //     dispatch(updateInventory(inventory));
                // }

                dispatch(fetchAndCacheLabsForReferal());

                dispatch(fetchAndCachePtVitals(px.patient.id));

                dispatch(sanitizePrescription(state.session.medElements));
            }, 1000);

            setTimeout(() => {
                addLabTestsStatus(dispatch, state, action);
                fetchSubstitutes(dispatch, state, action);
            }, 1500);

            fetchAndCacheDoctorPackages(dispatch);
            dispatch(setupPadGenieAutoSuggest());
            dispatch(copyCareCanvas(state.prescriptionPad.prescription.careCanvas));
            break;

        case UPSERT_PRESCRIPTION:
        case UPSERT_PRESCRIPTION_V2:
            if (!state.prescriptionPad.prescription) break;
            onSymDiaChange(
                dispatch,
                action,
                state.prescriptionPad.prescription.symptoms,
                state.prescriptionPad.prescription.diagnosis,
                true,
            );
            state.prescriptionPad.prescription.medications &&
                onMedicationChange(
                    state.prescriptionPad.prescription.medications,
                    dispatch,
                    action,
                );

            addLabTestsStatus(dispatch, state, action);
            fetchSubstitutes(dispatch, state, action);

            const meds = state.prescriptionPad.prescription?.medications;
            if (!meds) break;

            computeFollowUpfromMedDuration(meds, dispatch, state);

            updatePrintConfigWithDForm(state, dispatch);
            break;

        case LOAD_PRESCRIPTION_TEMPLATE: {
            if (!state.prescriptionPad.prescription) break;
            setLabRefer(state, dispatch);

            onSymDiaChange(
                dispatch,
                action,
                state.prescriptionPad.prescription.symptoms,
                state.prescriptionPad.prescription.diagnosis,
                true,
            );
            state.prescriptionPad.prescription.medications &&
                onMedicationChange(
                    state.prescriptionPad.prescription.medications,
                    dispatch,
                    action,
                );

            addLabTestsStatus(dispatch, state, action);
            fetchSubstitutes(dispatch, state, action);
            if (action.type === LOAD_PRESCRIPTION_TEMPLATE) {
                dispatch(copyCareCanvas(action.pt.careCanvas));
            }
            const meds = state.prescriptionPad.prescription?.medications;
            if (!meds) break;

            computeFollowUpfromMedDuration(meds, dispatch, state);
            break;
        }

        case UNDO_ACTION: {
            if (!state.prescriptionPad.prescription) break;

            const meds = state.prescriptionPad.prescription?.medications;
            if (!meds) break;

            computeFollowUpfromMedDuration(meds, dispatch, state);
            break;
        }

        case UPSERT_MEDICATION:
        case DELETE_MEDICATION: {
            const meds = state.prescriptionPad.prescription?.medications;
            if (!meds) break;

            computeFollowUpfromMedDuration(meds, dispatch, state);
            onMedicationChange(meds, dispatch, action);
            fetchSubstitutes(dispatch, state, action);
            break;
        }
        case REPLACE_HE_MEDICATION: {
            const meds = state.prescriptionPad.prescription?.medications;
            if (!meds) break;

            computeFollowUpfromMedDuration(meds, dispatch, state);
            onMedicationChange(meds, dispatch, action);
            break;
        }
        case FETCH_DRUGS_SUBSTITUTE:
            fetchSubstitutes(dispatch, state, action);
            break;
        case COPY_DURATION_IN_MED: {
            const meds = state.prescriptionPad.prescription?.medications;
            if (!meds) break;

            computeFollowUpfromMedDuration(meds, dispatch, state);
            break;
        }
        case FETCH_SNACKING_QUESTIONS: {
            const { onSuccess } = action;
            try {
                const version = localStorage.getItem(SNACKING_QUESTIONS_VERSION) || '';
                const {
                    status,
                    questions,
                    doctorProfile,
                    version: parchiVersion,
                    error,
                } = await getSnackingQuestions(version);
                if (status === 'success') {
                    await clearTable(getMyDbId() || '', DB_TABLES['snackingQuestions']);
                    await updateG(
                        getMyDbId() || '',
                        DB_TABLES['snackingQuestions'],
                        questions as GenieItem[],
                    );
                    const today = new Date().toISOString().slice(0, 10);
                    localStorage.setItem(SNACKING_QUESTIONS_FETCH_DATE, today);
                    localStorage.setItem(PARCHI_SNACKING_QUESTIONS_VERSION, parchiVersion);
                    if (doctorProfile) {
                        localStorage.setItem(
                            SNACKING_DOCTOR_PROFILE,
                            JSON.stringify(doctorProfile),
                        );
                    } else {
                        localStorage.removeItem(SNACKING_DOCTOR_PROFILE);
                    }
                    onSuccess && onSuccess();
                } else {
                    console.error(error);
                }
            } catch (err) {
                console.error(err);
                captureError(err as Error);
            }
            break;
        }
        case ANSWER_SNACKING_QUESTION: {
            const docId = getDoc()?._id;
            const { skipPushToBE, setIsUpdateGenieLoading, setIsFetchingQuestions } = action;

            try {
                if (skipPushToBE) return;

                const { error } = await answerSnackingQuestions(action.newMed);
                if (error) {
                    console.log(error);
                    captureErrorString(error);
                } else if (Array.isArray(action.newMed)) {
                    localStorage.setItem(SNACKING_QUESTIONS_VERSION, String(action.version));
                    localStorage.removeItem(SNACKING_DOCTOR_PROFILE);
                }
            } catch (err) {
                console.log(err);
            } finally {
                if (action.isLast) {
                    dispatch(fetchSnackingQuestions(setIsFetchingQuestions));
                    docId && dispatch(fetchMyGenie(undefined, undefined, setIsUpdateGenieLoading));
                }
            }
            break;
        }
        case SETUP_PAD_GENIE_AUTO_SUGGEST: {
            const docid = state.prescriptionPad.prescription?.doctor._id || '';
            if (docid) {
                PadGenieAutoSuggestFuseManager.initializePadGenieAutoSuggestFuse(docid);
            }
            break;
        }
        case COPY_CARE_CANVAS: {
            const { careCanvas } = action;
            const prescriptionId = state.prescriptionPad.prescription?.id;
            if (!careCanvas || !prescriptionId) break;
            onCopyCareCanvas(dispatch, careCanvas, prescriptionId);
            break;
        }
        default:
    }
};

const getFollowupDays = (v: number, u: string): number | undefined => {
    const t = u.toLowerCase();
    if (t === 'days' || t === 'day' || t === 'day(s)') {
        return v;
    } else if (t === 'weeks' || t === 'week' || t === 'week(s)') {
        return v * 7;
    } else if (t === 'months' || t === 'month' || t === 'month(s)') {
        return v * 30;
    } else if (t === 'years' || t === 'year' || t === 'year(s)') {
        return v * 375;
    }

    return undefined;
};

const createAppReduxMiddleware = () => (api: MiddlewareAPI<Dispatch, GlobalState>) => {
    return (next: Dispatch<Actions>) => (action: Action) => {
        const result = next(action);

        handleAction(action, api.getState(), api.dispatch).catch((err) => {
            console.log('appMiddleware: Error handelling action', err);
            captureErrorString('appMiddleware: Error handelling action ' + err.message);
        });
        return result;
    };
};

const appReduxMiddleware = createAppReduxMiddleware();

export default appReduxMiddleware;

//  takes the keys of genie which are to be pushed to BE
// TODO: this func needs to take care, from which db data needs to be picked
export const pushGenieToBE = async (id: string, keys: GenieKeys[]): Promise<void> => {
    const keysThatNeedsToBePushed: Set<GenieKeys> = new Set([...keys, 'id', 'version']);

    try {
        // doctor level
        const advices = await getGArray<GAdvice>(id, DB_TABLES['advices']);
        const diagnosis = await getGArray<GSymptomsDiagnosis>(id, DB_TABLES['diagnosis']);
        const labTests = await getGArray<GLabTest>(id, DB_TABLES['labTests']);
        const vitals = await getGArray<GVitals>(id, DB_TABLES['vitals']);
        const medications = await getGArray<GMedication>(id, DB_TABLES['medications']);
        const symptoms = await getGArray<GSymptomsDiagnosis>(id, DB_TABLES['symptoms']);
        const injections = await getGArray<GInjection>(id, DB_TABLES['injections']);
        const templates = await getGArray<GSymptomsDiagnosis>(
            id,
            DB_TABLES['prescriptionTemplates'],
        );
        const examinations = await getGArray<GSymptomsDiagnosis>(id, DB_TABLES['examinations']);
        const printConfig = await getPrintConfig(id);
        const keyVitals = await getItemFromMisc<string[]>(id, MISC_KEYS.keyVitals);
        const vitalsConfig = await getItemFromMisc<GVitalConfig>(id, MISC_KEYS.vitalsConfig);
        const calculatorConfig = await getItemFromMisc<GCalculatorsConfig>(
            id,
            MISC_KEYS.calculatorConfig,
        );
        const sectionNameConfig = await getItemFromMisc<SectionNameConfig>(
            id,
            MISC_KEYS.sectionNameConfig,
        );
        const followUp = await getGArray<GFollowUp>(id, DB_TABLES['followUp']);
        const refer = await getGArray<GRefer>(id, DB_TABLES['refer']);
        const translate = await getItemFromMisc<Translate>(id, MISC_KEYS.translate);
        const padDyForm = await getGArray<GDyForm>(id, DB_TABLES['dyForm']);
        const medFrequency = await getGArray<GMedFrequency>(id, DB_TABLES['medFrequency']);
        const medSOA = await getGArray<GMedSOA>(id, DB_TABLES['medSOA']);
        const medTiming = await getGArray<GMedTiming>(id, DB_TABLES['medTiming']);
        const labVitals = await getGArray<GLabVitalEntity>(id, DB_TABLES['labVitals']);
        const ltTemplates = await getGArray<GLTTemplate>(id, DB_TABLES['gLTTemplates']);
        const medTemplates = await getGArray<GMedTemplate>(id, DB_TABLES['gMedTemplates']);
        const injectionTemplates = await getGArray<GInjectionTemplate>(
            id,
            DB_TABLES['gInjectionTemplates'],
        );
        const labVitalsTemplates = await getGArray<GLabVitalTemplate>(
            id,
            DB_TABLES['gLabVitalsTemplates'],
        );
        const examinationsTemplates = await getGArray<GExaminationsTemplate>(
            id,
            DB_TABLES['gExaminationsTemplates'],
        );
        const proceduresTemplates = await getGArray<GProceduresTemplate>(
            id,
            DB_TABLES['gProceduresTemplates'],
        );
        const symTemplates = await getGArray<GSymTemplate>(id, DB_TABLES['gSymTemplates']);
        const diaTemplates = await getGArray<GDiaTemplate>(id, DB_TABLES['gDiaTemplates']);
        const medicalHistoryConfig = await getItemFromMisc<GMedicalHistoryConfig>(
            id,
            MISC_KEYS.medicalHistoryConfig,
        );

        // to be decided
        const staffRestriction = await getItemFromMisc<SR[]>(id, MISC_KEYS.staffRestriction);
        const extraFlags = await getItemFromMisc<ExtraFlags>(id, MISC_KEYS.extraFlags);

        // to be decided
        const ptColumns = await getPtColumns();
        const dbSettings = await getItemFromMisc<GenieSettings>(id, MISC_KEYS.settings);

        const allKeys = new Set(dbSettings.padElements.map((t) => t.id));

        let uniquePadElemts: GeniePadElementsSettingItem[] = dbSettings.padElements;

        if (allKeys.size !== dbSettings.padElements.length) {
            uniquePadElemts = Array.from(allKeys).map((t) => {
                const configs = dbSettings.padElements.filter((item) => item.id === t);

                if (configs.length === 1) {
                    return configs[0];
                }

                return {
                    id: t,
                    name: configs[0].name,
                    isShown: configs.find((item) => item.isShown)?.isShown || false,
                    isAutoCopy: configs.find((item) => item.isAutoCopy)?.isAutoCopy || false,
                };
            });
        }

        const settings = { ...dbSettings, padElements: uniquePadElemts };
        const services = await getGArray<GService>(id, DB_TABLES['services']);
        const medicalRecordsTags = await getGArray<GMedicalRecordsTags>(
            id,
            DB_TABLES['medicalRecordsTags'],
        );

        const { version } = await getItemFromMisc<GenieVersion>(id, MISC_KEYS.genieVersion);

        const payload = {
            id: id,
            advices,
            diagnosis,
            labTests,
            vitals,
            medications,
            injections,
            symptoms,
            templates,
            examinations,
            printConfig,
            ptColumns,
            settings,
            medicalHistoryConfig,
            vitalsConfig: changeVitalIdFromVToLBInVitalsConfig(vitalsConfig),
            calculatorConfig,
            sectionNameConfig,
            followUp,
            services,
            translate,
            padDForms: padDyForm,
            medFrequency,
            medSOA,
            medTiming,
            labVitals,
            ltTemplates,
            medTemplates,
            injectionTemplates,
            labVitalsTemplates,
            examinationsTemplates,
            symTemplates,
            diaTemplates,
            medicalRecordsTags,
            refer,
            version,
            staffRestriction,
            keyVitals,
            extraFlags,
            proceduresTemplates,
        };

        // TODO: this needs to be optimised to fetch only those keys which are required from the db
        Object.keys(payload).forEach((key) => {
            if (!keysThatNeedsToBePushed.has(key as GenieKeys)) {
                // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                // @ts-ignore
                delete payload[key as GenieKeys];
            }
        });

        await pushGenie(id, payload);
    } catch (e) {
        console.error('pushGenie => ', e);
    }
};

const setLabRefer = (
    state: GlobalStateV1,
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
): void => {
    const labTestsCount = getLabTests(state).length;
    let selectedLabToRefer: DocNetworkEntity | undefined;
    if (labTestsCount === 0) {
        selectedLabToRefer = undefined;
    } else {
        const labsAvailableToRefer = getLabsAvailableToRefer(state);
        selectedLabToRefer =
            getSelectedLabToReferId(state) !== undefined &&
            labsAvailableToRefer &&
            labsAvailableToRefer.length > 0 &&
            labsAvailableToRefer[0].network &&
            labsAvailableToRefer[0].network?.length > 0
                ? labsAvailableToRefer[0].network.find(
                      (t) => t._id.toString() === getSelectedLabToReferId(state)?.toString(),
                  )
                : undefined;
    }

    const referOptionsData = getAvailableToReferData(state);
    const px = getPrescription(state);

    const labSpeciality = referOptionsData && referOptionsData.lab && referOptionsData.lab[0];

    if (!labSpeciality || !px || !referOptionsData) {
    } else {
        dispatch(
            updateLabReferal(
                selectedLabToRefer
                    ? {
                          name: labSpeciality.name,
                          s_name: labSpeciality.s_name,
                          id: labSpeciality.id,
                          patientid: px.patient.id || px.patient.localId,
                          note: undefined,
                          campaign: referOptionsData.campaign,
                          eka_note: undefined,
                          refer_to_eka: false,
                          created_at: new Date().toISOString(),
                          lab: [selectedLabToRefer],
                      }
                    : undefined,
            ),
        );
    }
};

function updatePrintConfigWithDForm(
    state: GlobalStateV1,
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
) {
    getPrintConfig(getMyDbId() || '').then((pc) => {
        const dyPc: { [k: string]: boolean } = {};
        state.prescriptionPad.prescription?.dyform?.forEach((dy) => {
            dyPc[dy.id] = true;
            PRINT_CONFIGS_KEYS_TO_LABEL[dy.id] = dy.name;
        });
        dispatch(loadPrintConfig({ ...pc, dyform: { ...dyPc, ...pc.dyform } }));
    });

    getGArray<GDyForm>(getMyDbId() || '', DB_TABLES['dyForm']).then((d) => {
        d.forEach((dy) => {
            PRINT_CONFIGS_KEYS_TO_LABEL[dy.id] = dy.name;
        });
    });

    getItemFromMisc<GenieSettings>(getMyDbId() || '', MISC_KEYS.settings).then((settings) => {
        const dyForm = settings.padElements?.filter((t) => !DEFAULT_PAD_CONFIG_KEY_SET.has(t.id));
        dyForm.forEach((dy: GeniePadElementsSettingItem) => {
            PRINT_CONFIGS_KEYS_TO_LABEL[dy.id] = dy.name;
        });
    });
}

async function autoCopy(
    state: GlobalStateV1,
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    visits: PatientDetailsVisits['data'] | undefined,
    vitals: LabVitalEntity[] | undefined,
    treatmentProcedures?: DentalProcedure[],
) {
    const px = state.prescriptionPad.prescription;

    if (!px) {
        return;
    }

    try {
        const lastVisit = visits?.sort((date1, date2) => {
            return date1 > date2 ? -1 : 1;
        })[0];

        if (!lastVisit) {
            return;
        }

        const autoCopyProperties = getPxElementConfig(state)
            ?.filter((config) => config?.isAutoCopy)
            ?.reduce((newPres, config) => {
                const dyElement = lastVisit?.dyform?.find((t) => t.id === config.id);

                if (dyElement) {
                    return {
                        ...newPres,
                        dyform: [...(newPres?.dyform || []), dyElement],
                    };
                }
                if (config.id === 'labTests') {
                    return {
                        ...newPres,
                        labTests: lastVisit?.['labTests']?.map((labTest) =>
                            omit(labTest, ['test_on', 'repeat_on']),
                        ),
                    };
                }

                if (vitals && config.id === 'labVitals') {
                    const finalVitals = mergeVitals(vitals, lastVisit?.['labVitals']);

                    return {
                        ...newPres,
                        labVitals: finalVitals,
                    };
                }

                if (config.id === PAD_CONFIG_FOLLOW_UP_ADVICES_ID) {
                    return {
                        ...newPres,
                        followup: lastVisit?.['followup'],
                        advices: lastVisit?.['advices'],
                    };
                }

                if (config.id === DENTAL_CHART) {
                    const toRemoveDentalProcedures =
                        Array.isArray(treatmentProcedures) && treatmentProcedures.length > 0;
                    const response: Partial<Prescription> = {
                        ...newPres,
                        dentalExaminations: lastVisit?.['dentalExaminations'],
                    };
                    if (!toRemoveDentalProcedures) {
                        response['dentalProcedures'] = lastVisit?.['dentalProcedures'];
                    }
                    return response;
                }

                return {
                    ...newPres,
                    [config.id]: lastVisit[config.id as keyof Tool],
                };
            }, {} as Partial<Prescription>);

        if (state?.session?.growthChart) {
            const gestationalAge = setGestationalAge(lastVisit);
            if (gestationalAge) {
                autoCopyProperties.vitals = [
                    ...(autoCopyProperties?.vitals?.filter((v) => v.id !== 'lb-5257276261') || []),
                    gestationalAge,
                ];
            }
        }

        batch(() => {
            dispatch(
                upsertPrescription({
                    ...autoCopyProperties,
                    meta: {
                        ...(px.meta || {}),
                        autoCopyStatus: 'COPIED',
                    },
                }),
            );
            const instructionColumn = state.session.medElements.find(
                (item) => item.id === 'instruction',
            );

            if (instructionColumn && instructionColumn.isShown) {
                const ptLang = state.prescriptionPad.prescription?.patient.formData?.find(
                    (t) => t.key === 'lang',
                )?.value;
                if (ptLang) {
                    dispatch(
                        loadTranslate({
                            ...(state.prescriptionPad.translate || { flag: true }),
                            lang: ptLang.toString(),
                        }),
                    );
                } else {
                    lastVisit.translateLang &&
                        dispatch(
                            loadTranslate({
                                ...(state.prescriptionPad.translate || { flag: true }),
                                lang: lastVisit.translateLang,
                            }),
                        );
                }
            }

            if (state.prescriptionPad.prescription?.meta?.autoCopyStatus === 'REQUIRED') {
                onGrowthChartChange(
                    dispatch,
                    autoCopyProperties.vitals || state.prescriptionPad.prescription?.vitals || [],
                    state.prescriptionPad.prescription?.patient?.profile?.personal?.gender as
                        | 'male'
                        | 'female',
                    state.prescriptionPad.prescription?.patient?.profile?.personal?.age,
                    !state?.session?.growthChart,
                );
            }
        });
    } catch (error) {
        console.log(error);
        captureError(error as Error);
        track('autoCopy', { fetchAllVisits: 'failed2' });
    }
}

function setGestationalAge(
    lastVisit?: Tool & {
        date: string;
        visitId: string;
        precriptionId?: string;
        flavour?: string;
        translateLang?: string;
    },
) {
    const vitalData = lastVisit?.vitals?.find((vital) => vital.id === 'lb-5257276261');

    if (vitalData) {
        const daysPassed = moment(new Date()).diff(lastVisit?.date, 'days');

        if (Number(vitalData.value.qt) + Math.abs(Number(daysPassed)) <= 350) {
            const option = {
                ...vitalData,
                value: {
                    ...vitalData.value,
                    qt: (Number(vitalData.value.qt) + Number(daysPassed))?.toString(),
                },
            };

            return removeUnwatedKeys(option);
        } else {
            notification.error({
                message:
                    'The maximum gestational age allowed is 50 weeks and 0 days. WHO/IAP chart is active now',
                duration: 20,
            });
        }
    }

    return undefined;
}

function computeFollowUpfromMedDuration(
    meds: MedicationsEntity[],
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    state: GlobalStateV1,
) {
    if (!state.session.autoFillFollowUp) {
        return;
    }
    const { prescription } = state.prescriptionPad;
    let largetD = 0;
    for (let i = 0; i < meds.length; i++) {
        const s = meds[i].duration?.custom?.split(' ');
        const v = s?.length === 2 && parseInt(s[0]);
        if (s?.length === 2 && v && !isNaN(v)) {
            const followUpDays = getFollowupDays(v, s[1]);
            if (followUpDays !== undefined) {
                largetD = Math.max(largetD, followUpDays);
            }
        }
    }

    if (largetD) {
        const fDate = moment(new Date().toDateString()).add(largetD, 'day');
        dispatch(
            setFollowup(
                fDate.toISOString(),
                'MED_D',
                state.prescriptionPad.prescription?.followup?.notes,
            ),
        );
    } else if (prescription?.followup?.optionId) dispatch(setFollowup(undefined));
}

function onMedicationChange(
    medications: MedicationsEntity[],
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    action: Actions,
) {
    // medications &&
    //     medications.length > 0 &&
    //     dispatch(cacheComplimentaryDrugs(medications[medications.length - 1].id));
    let newMedsIds: string[] = [];
    if (action.type === LOAD_PRESCRIPTION_TEMPLATE) {
        newMedsIds = (action.pt.medications || []).map((m) => m.id);
    } else if (action.type === UPSERT_MEDICATION && action._isNewMedIntroduced) {
        newMedsIds = Array.isArray(action.medication)
            ? action.medication.map((m) => m.id)
            : [action.medication.id];
    } else if (action.type === REPLACE_HE_MEDICATION) {
        newMedsIds = Object.keys(action.substitutes);
    } else if (
        action.type === APPLY_DRAFT ||
        action.type === LOAD_PRESCRIPTION ||
        action.type === UPSERT_PRESCRIPTION ||
        action.type === UPSERT_PRESCRIPTION_V2
    ) {
        newMedsIds = medications.map((m) => m.id);
    }

    if (newMedsIds.length) {
        dispatch(fetchAndUpdateLatestDrugInfo(newMedsIds));
    }

    if (medications.length === 0) return;
    const drugs = medications.map((m) => ({
        id: m.id,
        gen_id: m.generic_id,
        form: m.df_id,
        product_type: m.product_type,
    }));

    medications && dispatch(cacheDrugInteractions(drugs));
}

async function onGrowthChartChange(
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    totalVitals: VitalsEntity[],
    gender: 'male' | 'female',
    age?: Age,
    deleteGCVitals?: boolean,
) {
    try {
        if (deleteGCVitals) {
            dispatch(
                setVitals([...(totalVitals?.filter((v) => !GROWTH_CHART_RESULTS?.[v?.id]) || [])]),
            );
            return;
        }

        const data = await fetchAndStoreGrowthChartData();

        if (!data) {
            throw new Error('onGrowthChartChange => failed to fetch growth chart data');
        }

        const growthVitals = getGrowthChartZindexAndPercentileVitals(
            data,
            totalVitals,
            gender as 'male' | 'female',
            age,
        );

        dispatch(
            setVitals([
                ...(totalVitals?.filter((v) => !GROWTH_CHART_RESULTS?.[v?.id]) || []),
                ...growthVitals,
            ]),
        );
    } catch (error) {
        dispatch(setVitals([...totalVitals]));
        captureError(error as Error);
        track('ERROR', {
            on: 'onGrowthChartChange',
            error: (error as Error).message,
        });
    }
}

function onSymDiaChange(
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    action: Actions,
    symptoms?: DiagnosisEntityOrSymptomsEntity[],
    diagnosis?: DiagnosisEntityOrSymptomsEntity[],
    isUpdateProperties?: boolean,
) {
    const symIds = symptoms ? filterIdUsingStartsWithAndJoin(symptoms, LOCAL_ID_PREFIX) : '';
    const diaIds = diagnosis ? filterIdUsingStartsWithAndJoin(diagnosis, LOCAL_ID_PREFIX) : '';

    dispatch(cacheDrugsLabTestsFromSymDia(symIds, diaIds));
    dispatch(cacheRelatedSymDiaFromSymDia(symIds, diaIds));

    if (isUpdateProperties) {
        let sIds = '',
            dIds = '';
        if (action.type === UPSERT_SYMPTOM) {
            sIds = action.sysptom.id;
        } else if (action.type === UPSERT_DIAGNOSE) {
            dIds = action.diagnose.id;
        } else if (
            action.type === LOAD_PRESCRIPTION ||
            action.type === LOAD_PRESCRIPTION_TEMPLATE
        ) {
            (sIds = symIds), (dIds = diaIds);
        }

        dispatch(cacheSymDiaProperties(sIds, dIds));
    }
}

export const sanitizeFinalPrescriptionFunction = (prescription: Prescription): Prescription => {
    const labVitals = prescription.labVitals?.filter(
        (i) => i.interpretation || i.value || i.remark || i.is_panel,
    );
    const dyform = prescription.dyform?.filter((i) => {
        i.elements = i.elements?.filter((i) => i.name || i.value);
        return i.elements?.length;
    });
    prescription.dentalExaminations?.forEach((i) => {
        delete i.index;
    });

    interface OpData {
        ucdva?: { value?: string };
        ucnva?: { value?: string };
        ph?: { value?: string };
        bcdva?: { value?: string };
        bcnva?: { value?: string };
        nct?: { value?: string };
        gat?: { value?: string };
        cct?: { value?: string };
        ciop?: { value?: string };
        sph?: { value?: string };
        cyl?: { value?: string };
        axis?: { value?: string };
        add?: { value?: string };
        dva?: { value?: string };
        nva?: { value?: string };
    }

    const filterOpData = <T extends OpData & { id: string }>(data: T[], pxKey: PX_OP_KEYS) => {
        const columns = getColumns(pxKey);
        const keys = columns.map((col) => col.key);
        const opthalUIOrder = getUITable<T & OptionTypeBase>(data as (T & OptionTypeBase)[], pxKey);
        const sortedOphthalData = !opthalUIOrder?.length
            ? data
            : data?.slice()?.sort((a, b) => {
                  const indexA = opthalUIOrder.findIndex((t) => t.id === a.id);
                  const indexB = opthalUIOrder.findIndex((t) => t.id === b.id);
                  return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
              });
        return sortedOphthalData?.filter((item) =>
            keys.some((key) => item[key]?.value !== undefined && item[key]?.value !== null),
        );
    };

    const opVision = filterOpData(prescription.opVision || [], 'opVision');
    const opIop = filterOpData(prescription.opIop || [], 'opIop');
    const opAutoRefraction = filterOpData(prescription.opAutoRefraction || [], 'opAutoRefraction');
    const opCurrentSpec = filterOpData(prescription.opCurrentSpec || [], 'opCurrentSpec');
    const opFinalPrescription = filterOpData(
        prescription.opFinalPrescription || [],
        'opFinalPrescription',
    );
    const opSubjectiveRefraction = filterOpData(
        prescription.opSubjectiveRefraction || [],
        'opSubjectiveRefraction',
    );

    prescription.dentalProcedures?.forEach((i) => {
        delete i.index;
    });
    return {
        ...prescription,
        labVitals,
        dyform,
        opVision,
        opAutoRefraction,
        opCurrentSpec,
        opFinalPrescription,
        opIop,
        opSubjectiveRefraction,
    };
};

function addLabTestsStatus(
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    state: GlobalState,
    action: Actions,
) {
    if (!isOnboardedForLab()) return;

    const { labTests = [] } = state.prescriptionPad.prescription || {};

    const validActions = new Set([
        LOAD_PRESCRIPTION,
        UPSERT_PRESCRIPTION,
        LOAD_PRESCRIPTION_TEMPLATE,
    ]);
    const fetchForActions =
        validActions.has(action.type) || (action as UpsertLabTestAction).doApiCall;

    if (!fetchForActions) return;

    fetchDrugsLabTestsStatus([], labTests as ItemType[]).then((response) => {
        if (validActions.has(action.type) || action.type === UPSERT_LAB_TEST) {
            dispatch(updateLabTests(response));
        }
    });
}

async function fetchSubstitutes(
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    state: GlobalState,
    action: Actions,
) {
    if (!isOnboardedForPharma()) return;

    const { pincode: pincodeForSubstitutions } = state.session;

    const { prescriptionPad: { prescription } = {} } = state;

    if (!prescription) return;

    const { patient, doctor, clinic } = prescription;
    const patientId = patient.id || patient.localId;
    const patientPin = patient?.formData?.find((i) => i.key === 'pincode')?.value;
    const clinicPin = clinic.address?.pin;

    const clinics = doctor.profile.professional.clinics || [];
    const currentClinicId = doctor.profile.professional.default_clinic;
    const defaultClinicPin = clinics.find((i) => i._id === currentClinicId)?.address?.pin;

    const pincode = patientPin || clinicPin || defaultClinicPin || '';

    const validActions = new Set([
        DELETE_MEDICATION,
        LOAD_PRESCRIPTION,
        UPSERT_PRESCRIPTION,
        LOAD_PRESCRIPTION_TEMPLATE,
        CLEAR_PRESCRIPTION,
    ]);
    const fetchForActions =
        validActions.has(action.type) ||
        action.type === UPSERT_MEDICATION ||
        pincodeForSubstitutions;

    if (!fetchForActions) return;

    const { medications = [] } = state.prescriptionPad.prescription || {};

    if (!medications.length) return;
    dispatch(setDrugsSubstitute([]));

    const docId = getMySingleDoctorId() || '';

    try {
        const { success, substituteArray = [], statusObject = {} } = await fetchDrugsSubstitute(
            docId,
            {
                medications,
                patient_id: patientId,
                pincode: pincodeForSubstitutions || String(pincode),
            },
        );
        if (success) {
            dispatch(setDrugsSubstitute(substituteArray || []));
            dispatch(updateMedications(statusObject));
        } else {
            track('ERROR', {
                on: 'fetchDrugsSubstitute',
                error: 'fetch drugs substitute api failed',
            });
        }
    } catch (error) {
        captureError(error as Error);
        track('ERROR', {
            on: 'fetchDrugsSubstitute',
            error: (error as Error).message,
        });
    }
}

async function fetchAndCacheDoctorPackages(dispatch: ThunkDispatch<GlobalStateV1, null, Actions>) {
    if (!isOnboardedForLab()) return;
    const docId = getMySingleDoctorId() || '';

    try {
        const { success, vendor_packages } = await fetchDoctorPackages(docId);
        if (success) {
            dispatch(setDoctorPackages(vendor_packages || []));
        } else {
            track('ERROR', {
                on: 'fetchDoctorPackages',
                error: 'fetch doctor packages api failed',
            });
        }
    } catch (error) {
        captureError(error as Error);
        track('ERROR', {
            on: 'fetchDoctorPackages',
            error: (error as Error).message,
        });
    }
}

const onCopyCareCanvas = async (
    dispatch: ThunkDispatch<GlobalStateV1, null, Actions>,
    careCanvas: CareCanvas[],
    prescriptionId: string,
) => {
    const careCanvasId = careCanvas?.[0]?.id || '';
    if (!careCanvasId || !prescriptionId) return;
    const id = `care-canvas-${prescriptionId.toLocaleLowerCase()}`;
    if (careCanvasId === id) {
        dispatch(upsertCareCanvas(careCanvas));
        return;
    }
    try {
        const { success, template, error } = await getCareCanvasTemplate(careCanvasId);
        if (success) {
            if (template) {
                const { uploaded_image, final_image } = template;
                const uploadedImageDataUrl = await imageToBase64(uploaded_image);
                const finalImageDataUrl = await imageToBase64(final_image);
                if (!uploadedImageDataUrl || !finalImageDataUrl) {
                    track('ERROR', {
                        on: 'imageToBase64',
                    });
                    return;
                }
                const uploadedImageUrl = await uploadImage(
                    uploadedImageDataUrl,
                    `base-image-${id}`,
                );
                const finalImageUrl = await uploadImage(finalImageDataUrl, `final-image-${id}`);
                if (!uploadedImageUrl || !finalImageUrl) {
                    track('ERROR', {
                        on: 'uploadImage',
                    });
                    return;
                }
                const careCanvasTemplate = {
                    ...template,
                    _id: id,
                    uploaded_image: uploadedImageUrl,
                    final_image: finalImageUrl,
                };
                const { success, error } = await uploadCareCanvasTemplate(careCanvasTemplate);
                const careCanvas = {
                    id: id,
                    name: template.name,
                    final_image: template.final_image,
                };
                if (success) {
                    dispatch(upsertCareCanvas([careCanvas]));
                } else {
                    notification.error({
                        message: 'Failed to copy canvas template',
                        duration: 5,
                    });
                    track('ERROR', {
                        on: 'copyCanvasDetails',
                        what: error,
                    });
                }
            } else {
                track('ERROR', {
                    on: 'copyCanvasDetails',
                    what: error,
                });
            }
        } else {
            notification.error({
                message: 'Failed to get canvas template',
                duration: 5,
            });
            track('ERROR', { on: 'copyCanvasDetails', what: error });
        }
    } catch (error) {
        notification.error({
            message: 'Failed to copy canvas template',
            duration: 5,
        });
        captureError(error as Error);
        track('ERROR', { on: 'copyCanvasDetails', what: (error as Error).message });
    }
};
